import { render, staticRenderFns } from "./AdditionalInputItems.vue?vue&type=template&id=e0f10b36&scoped=true&"
import script from "./AdditionalInputItems.vue?vue&type=script&lang=ts&"
export * from "./AdditionalInputItems.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalInputItems.vue?vue&type=style&index=0&id=e0f10b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f10b36",
  null
  
)

export default component.exports